const AgentsDetail = [
    {
        id:"1",
        Image:"./Agents-Images/charlie-green-3JmfENcL24M-unsplash.jpg",
        name:"Tomas Hardy",
        info:"Busnines Agent"
    },
    {
        id:"2",
        Image:"./Agents-Images/cibelly-roberta-SE4Xc1WvIkU-unsplash.jpg",
        name:"Jack Sparrow",
        info:"Busnines Agent"
    },
    {
        id:"3",
        Image:"./Agents-Images/pexels-djordje-petrovic-2102415.jpg",
        name:"Mical Hardy",
        info:"Busnines Agent"
    },
    {
        id:"4",
        Image:"./Agents-Images/pexels-edmond-dantès-4339954.jpg",
        name:"Jaff Shalbay",
        info:"Busnines Agent"
    },
]
export default AgentsDetail